/* license-copyright */

import '../types/externs'
import myNewPackage from './'

module.exports = {
  '_myNewPackage': myNewPackage,
}